import { v1ApiClient } from '..';

const utilService = {
  fetchRegionList: async (workspaceAlias: string): Promise<RegionT[]> => {
    try {
      const res = await v1ApiClient.get(
        `/workspaces/${workspaceAlias}/regions`,
      );
      return res.data;
    } catch (e) {
      throw e;
    }
  },
  fetchLanguageList: async (workspaceAlias: string): Promise<LanguageT[]> => {
    try {
      const res = await v1ApiClient.get(
        `/workspaces/${workspaceAlias}/languages`,
      );
      return res.data;
    } catch (e) {
      throw e;
    }
  },
};

export default utilService;
